module.exports = __webpack_public_path__ + "img/question18.b2e4e84f.png";